import { Component } from "react"

class HuggingFaceId extends Component {
    constructor(props){
        super(props)
        this.name = "Hugging Face ID"
    }
    validate(callbackDialog,requireCheck){
        if(requireCheck && String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        if(String(this.props).trim().length > 0){
            if(this.props.length > 64){
                callbackDialog("エラー",this.name + "は64文字以内にしてください。")
                return false
            }
            /*if(!/^[a-zA-Z0-9-]{1,64}$/.test(this.props)){
                callbackDialog("エラー",this.name + "の形式ではありません。")
                return false
            }*/
        }
        return true
    }
}

export default HuggingFaceId;